<div style="flex-wrap: wrap;" class="flex-row gap-5">
  <img *ngFor="let paymentMethod of paymentMethods" class="payment-method-images" [src]="'assets/icons/payment-methods/' + paymentMethod + '.png'" alt="">
</div>
